import { BoxTemplates } from './BoxTemplates';

export default BoxTemplates;
